module.exports = __webpack_public_path__ + "media/images/builder/avatar-07689f42536248fb75707d4f48228e01.png";